import React from 'react';

import isEmpty from 'lodash/isEmpty';

import {
  SidePage,
  Section,
  TypographyListItem,
  DescriptionList,
  DescriptionItem,
} from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import { EditCountryGroup } from 'scenes/CountryGroups/components/CountryGroupForm';
import { useLoadCG, useIsUpdating } from 'scenes/CountryGroups/data';

import Actions from '../Actions';

const CountryGroupDetails = ({ id, onClose, onExited, open }) => {
  const isUpdating = useIsUpdating();
  const [childComponent, openChildComponent] = useChildComponent();
  const { data, isLoading, isRefetching } = useLoadCG(id);

  const handleDelete = async () => {
    onClose();
  };

  const handleEdit = async () => {
    openChildComponent(EditCountryGroup, {
      id,
    });
  };

  return (
    <SidePage
      backdrop={false}
      onClose={onClose}
      onExited={onExited}
      loading={isLoading || isUpdating}
      fetching={isRefetching}
      open={open}
      width={800}
    >
      <SidePage.Title
        title={`Country Group`}
        subTitle={data?.name}
        entityId={id}
      />
      <SidePage.NewBody wrapper={true} dense={true}>
        <SidePage.NewContent>
          {!isEmpty(data) ? (
            <Section title={'General'}>
              <DescriptionList disableGutters data={data}>
                <DescriptionItem
                  label={'Countries'}
                  field={'countries'}
                  type={'typographyList'}
                  listType={'bullet'}
                  item={({ name }) => {
                    return <TypographyListItem>{name}</TypographyListItem>;
                  }}
                />
              </DescriptionList>
            </Section>
          ) : null}
        </SidePage.NewContent>
        <SidePage.Sidebar
          actions={
            <Actions
              actions={data?.actions}
              data={data}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          }
        >
          {/* <MetaData data={data} /> */}
        </SidePage.Sidebar>
      </SidePage.NewBody>
      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
      {childComponent}
    </SidePage>
  );
};

export default CountryGroupDetails;
